import styled from 'styled-components';

const Button = styled.button`
  padding: 12px 30px;
  border-radius: 8px;
  color: #343439;
  font-size: inherit;
  background: white;
  border: 1px solid #343439;
  box-sizing: border-box;

  transition: all linear 0.1s;

  &:hover {
    color: white;
    background: #343439;
    cursor: pointer;
  }
`;

export default Button;
